import {
  info_panel_item_styles_default
} from "./chunk.YNKOQ2F6.js";
import {
  e,
  n
} from "./chunk.D5EJUUKV.js";
import {
  $,
  s
} from "./chunk.4JTBA2KG.js";
import {
  __decorateClass
} from "./chunk.K2NRSETB.js";

// src/components/info-panel-item/info-panel-item.ts
var FadvInfoPanelItem = class extends s {
  render() {
    return $`<div part="base" class="info-panel-item"><fadv-typography type="label-small" class="info-panel-item__name" part="name" weight="700"><slot name="name">${this.name}</slot></fadv-typography><fadv-typography type="label-small" class="info-panel-item__value" part="value"><slot></slot></fadv-typography></div>`;
  }
};
FadvInfoPanelItem.styles = info_panel_item_styles_default;
__decorateClass([
  e({ reflect: true })
], FadvInfoPanelItem.prototype, "name", 2);
FadvInfoPanelItem = __decorateClass([
  n("fadv-info-panel-item")
], FadvInfoPanelItem);

export {
  FadvInfoPanelItem
};
